import { API_PRECOG_URL_V1 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const chartAccountsConstants = {
  GET_SEARCHED_ACCOUNTS_LIST_START: "GET_SEARCHED_ACCOUNTS_LIST_START",
  GET_SEARCHED_ACCOUNTS_LIST_SUCCESS: "GET_SEARCHED_ACCOUNTS_LIST_SUCCESS",
  GET_SEARCHED_ACCOUNTS_LIST_ERROR: "GET_SEARCHED_ACCOUNTS_LIST_ERROR"
};

export function getSearchedAccountsList(accountCode, includeSystem=false) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    // const precog = getState().precog;
    const managerId = main.accountantUuidSelected;
    const itemId = main.companyUuidSelected;
    // const source = precog?.invoiceDetail?.data?.source;
    
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/accounting/accounts?itemId=${itemId}&managerId=${managerId}&search=${accountCode}&includeSystem=${includeSystem}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: chartAccountsConstants.GET_SEARCHED_ACCOUNTS_LIST_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: chartAccountsConstants.GET_SEARCHED_ACCOUNTS_LIST_SUCCESS,
              payload: result
            });
            resolve(result);
          } else {
            dispatch({
              type: chartAccountsConstants.GET_SEARCHED_ACCOUNTS_LIST_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: chartAccountsConstants.GET_SEARCHED_ACCOUNTS_LIST_START,
            error: response
          });
          reject();
        });
    });
  };
}
